import React, { useState } from "react";
import DineshImg from "./Dinesh_image.jpeg";
import WashingMachineImg from "./wahsing_machine_image.avif";
import TvRepairImg from "./tv repair.jpg";
import LcdImg from "./lcd.jpg";
import LedImg from "./led.jpg";

const galleryItems = [
  {
    src: DineshImg,
    alt: "Expert TV technician Dinesh repairing LED TV circuit board at Mauli Services Pune",
    caption: "Expert Hands at Work",
    category: "Repair",
  },
  {
    src: TvRepairImg,
    alt: "Professional TV repair and screen diagnostics service at Mauli Services Pimpri Chinchwad",
    caption: "TV Diagnostics & Repair",
    category: "TV Repair",
  },
  {
    src: LcdImg,
    alt: "LCD TV panel replacement and repair service in Pune by Mauli Services",
    caption: "LCD Panel Service",
    category: "LCD Repair",
  },
  {
    src: LedImg,
    alt: "LED TV backlight repair and replacement at Mauli Services workshop Pune",
    caption: "LED TV Solutions",
    category: "LED Repair",
  },
  {
    src: WashingMachineImg,
    alt: "Washing machine repair and service by Mauli Services technicians in Pune",
    caption: "Washing Machine Service",
    category: "Appliance",
  },
];

const GallerySection = () => {
  const [lightbox, setLightbox] = useState(null);

  const openLightbox = (index) => setLightbox(index);
  const closeLightbox = () => setLightbox(null);
  const nextImage = () => setLightbox((prev) => (prev + 1) % galleryItems.length);
  const prevImage = () => setLightbox((prev) => (prev - 1 + galleryItems.length) % galleryItems.length);

  return (
    <section id="gallery-section" className="section" aria-label="Our work gallery">
      <div className="section-inner">
        <div className="section-header">
          <div className="section-label">Our Portfolio</div>
          <h2 className="section-title">Our Work in Action</h2>
          <p className="section-subtitle">
            Take a look at our workshop, expert technicians, and the quality repairs we deliver every day across Pune.
          </p>
        </div>

        <div className="gallery-grid">
          {galleryItems.map((item, index) => (
            <div
              key={index}
              className="gallery-item"
              onClick={() => openLightbox(index)}
              role="button"
              tabIndex={0}
              aria-label={`View ${item.caption}`}
              onKeyDown={(e) => e.key === "Enter" && openLightbox(index)}
            >
              <img
                src={item.src}
                alt={item.alt}
                className="gallery-image"
                loading="lazy"
                width="400"
                height="300"
              />
              <div className="gallery-overlay">
                <span className="gallery-category">{item.category}</span>
                <span className="gallery-caption">{item.caption}</span>
                <span className="gallery-zoom-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="11" cy="11" r="8" />
                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                    <line x1="11" y1="8" x2="11" y2="14" />
                    <line x1="8" y1="11" x2="14" y2="11" />
                  </svg>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightbox !== null && (
        <div className="lightbox-overlay" onClick={closeLightbox} role="dialog" aria-label="Image lightbox">
          <button className="lightbox-close" onClick={closeLightbox} aria-label="Close lightbox">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
          <button className="lightbox-nav lightbox-prev" onClick={(e) => { e.stopPropagation(); prevImage(); }} aria-label="Previous image">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img
              src={galleryItems[lightbox].src}
              alt={galleryItems[lightbox].alt}
              className="lightbox-image"
            />
            <div className="lightbox-caption">
              <span className="lightbox-caption-category">{galleryItems[lightbox].category}</span>
              <span>{galleryItems[lightbox].caption}</span>
            </div>
          </div>
          <button className="lightbox-nav lightbox-next" onClick={(e) => { e.stopPropagation(); nextImage(); }} aria-label="Next image">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
        </div>
      )}
    </section>
  );
};

export default GallerySection;
